import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryLightReachOffersDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * LightReach Energy Backup offers for the proposal's current server price,
 * with the saved selection, LightReach's price cap, and the server's own
 * select / refresh capabilities. Reading creates nothing at LightReach and
 * never reprices: a stale price comes back as `pricing_required`.
 */
export default function useBatteryLightReachOffers(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryLightReachOffersDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.lightReachOffers(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getLightReachOffers(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
